/**
 * Builds the message shown at the end of a sync. When the merge had to fall back to the receiver's field templates
 * because the donor supplied none (see mergeAndSave / findTemplateGaps in db/merge.ts), the user is told so instead of
 * seeing an unqualified success.
 * @param base The normal success message
 * @param templateWarnings Ids of the formTemplates whose field templates could not be verified
 * @returns The message to display
 */
export function syncTemplateWarningMessage(base: string, templateWarnings?: string[]): string {
	if (!templateWarnings || templateWarnings.length === 0) return base;
	const count = templateWarnings.length;
	return `${base}. ${count} form template${
		count === 1 ? "" : "s"
	} could not be verified during this sync, so the existing copies were used. If forms look wrong, sync again.`;
}
